import React, { useEffect, useState } from "react";
import { Modal, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { offerService } from "../../Services";
import { InfluencerRating } from "../../Components";
import { FileIcon } from "lucide-react";

const BrandOfferDetails = ({
  open,
  onClose,
  applicationId,
  applicaitonData,
}) => {
  const [applicationDetails, setApplicationDetails] = useState(null);
  console.log("🚀 ~ OfferDetails ~ applicationDetails:", applicationDetails);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open && applicationId) {
      fetchApplicationData(applicationId);
    }
  }, [applicationId]);

  function capitalizeFirstLetter(val) {
    return String(val)?.charAt(0)?.toUpperCase() + String(val)?.slice(1);
  }

  const statusRender = (status) => {
    const baseStyle =
      "inline-flex items-center gap-2 px-3 py-1 rounded-full text-sm font-medium";

    switch (status) {
      case "cancel_requested":
        return (
          <span className={`${baseStyle} bg-yellow-100 text-yellow-700`}>
            {status
              ?.replace(/_/g, " ")
              ?.replace(/\b\w/g, (c) => c.toUpperCase())}
          </span>
        );
      case "pending":
        return (
          <span className={`${baseStyle} bg-gray-100 text-gray-700`}>
            {capitalizeFirstLetter(status)}
          </span>
        );

      case "offered":
        return (
          <span className={`${baseStyle} bg-blue-100 text-blue-700`}>
            {capitalizeFirstLetter(status)}
          </span>
        );

      case "draft":
        return (
          <span className={`${baseStyle} bg-red-100 text-red-700`}>
            {capitalizeFirstLetter(status)}
          </span>
        );

      case "active":
        return (
          <span className={`${baseStyle} bg-green-100 text-green-700`}>
            active
          </span>
        );
      case "open":
        return (
          <span className={`${baseStyle} bg-green-100 text-green-700`}>
            open
          </span>
        );
      case "complete":
        return (
          <span className={`${baseStyle} bg-green-100 text-green-700`}>
            complete
          </span>
        );

      case "paused":
        return (
          <span
            className={`${baseStyle} bg-yellow-100 text-yellow-700`}
            title="Waiting for the brand’s acceptance"
          >
            <span>paused</span>
          </span>
        );
      case "pause":
        return (
          <span
            className={`${baseStyle} bg-yellow-100 text-yellow-700`}
            title="Waiting for the brand’s acceptance"
          >
            <span>pause</span>
          </span>
        );

      case "delete":
        return (
          <span
            className={`${baseStyle} bg-red-100 text-red-600`}
            title="Waiting for the brand’s acceptance"
          >
            <span>delete</span>
          </span>
        );
      case "deleted":
        return (
          <span
            className={`${baseStyle} bg-red-100 text-red-600`}
            title="Waiting for the brand’s acceptance"
          >
            <span>deleted</span>
          </span>
        );
      case "archive":
        return (
          <span
            className={`${baseStyle} bg-red-100 text-red-600`}
            title="Waiting for the brand’s acceptance"
          >
            <span>archive</span>
          </span>
        );
      case "archived":
        return (
          <span
            className={`${baseStyle} bg-red-100 text-red-600`}
            title="Waiting for the brand’s acceptance"
          >
            <span>archived</span>
          </span>
        );
      case "close":
        return (
          <span
            className={`${baseStyle} bg-red-100 text-red-600`}
            title="Waiting for the brand’s acceptance"
          >
            <span>close</span>
          </span>
        );
      case "closed":
        return (
          <span
            className={`${baseStyle} bg-red-100 text-red-600`}
            title="Waiting for the brand’s acceptance"
          >
            <span>closed</span>
          </span>
        );

      default:
        return (
          <span className={`${baseStyle} bg-gray-100 text-gray-600`}>
            {capitalizeFirstLetter(status)}
          </span>
        );
    }
  };

  const getPlatformIcon = (platformCode) => {
    const id = platformCode?.toString();

    switch (id) {
      case "IG":
        return (
          <div className="flex gap-2">
            <img
              src="/images/instagram.svg"
              alt="Instagram"
              width="24"
              height="24"
            />
          </div>
        );
      case "TT":
        return (
          <div className="flex gap-2">
            <img
              src="/images/tiktok-logo.svg"
              alt="TikTok"
              width="24"
              height="24"
            />
          </div>
        );
      case "FB":
        return (
          <div className="flex gap-2">
            <img
              src="/images/facebook.svg"
              alt="Facebook"
              width="24"
              height="24"
            />
          </div>
        );
      case "YT":
        return (
          <div className="flex gap-2">
            <img
              src="/images/youtube.svg"
              alt="Facebook"
              width="24"
              height="24"
            />
          </div>
        );
      default:
        return <span>{platformCode || "NA"}</span>;
    }
  };

  const fetchApplicationData = async (id) => {
    try {
      setLoading(true);
      // const res = await offerService.getApplicationData(id);
      const res = await offerService.getOfferDetailsByOfferId(id);
      console.log("🚀 ~ fetchApplicationData ~ res:", res);

      let parsed;
      if (typeof res === "string") {
        parsed = JSON.parse(res);
        if (typeof parsed === "string") {
          parsed = JSON.parse(parsed);
        }
      } else {
        parsed = res;
      }

      if (parsed.success === true || parsed.success === "true") {
        setApplicationDetails(parsed.data);
      } else {
        console.error("API returned unsuccessful response:", parsed);
      }
    } catch (error) {
      console.error("Error fetching application data:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading || !applicationDetails) {
    return (
      <Modal open={open} onClose={onClose}>
        <div className="flex items-center justify-center p-4 min-h-screen">
          <div className="bg-white rounded-lg p-8">
            <p>Loading offer details...</p>
          </div>
        </div>
      </Modal>
    );
  }
  const getOfferTypeBadge = (cmpType) => {
    const baseStyle =
      "inline-flex items-center gap-2 px-3 py-1 rounded-full text-sm font-medium";

    if (cmpType === "p") {
      return (
        <span className={`${baseStyle} bg-blue-100 text-blue-700`}>
          <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
            <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
            <path
              fillRule="evenodd"
              d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z"
              clipRule="evenodd"
            />
          </svg>
          Public
        </span>
      );
    } else if (cmpType === "r") {
      return (
        <span className={`${baseStyle} bg-orange-100 text-orange-700`}>
          <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
            <path
              fillRule="evenodd"
              d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
              clipRule="evenodd"
            />
          </svg>
          Private
        </span>
      );
    }

    return null;
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="application-details-modal"
      aria-describedby="application-details-description"
      className="flex items-center justify-center p-4"
    >
      <div className="relative w-full max-w-4xl max-h-[90vh] bg-white rounded-xl shadow-2xl outline-none overflow-hidden">
        <div className="sticky top-0 z-10 flex justify-between items-center p-6 py-3 border-b border-gray-200 bg-gradient-to-r from-green-600 to-green-700 text-white">
          <div>
            <Typography
              variant="h5"
              component="h2"
              className="font-bold text-white"
            >
              {applicationDetails?.product_name || "Untitled Campaign"}
            </Typography>
            <span className="text-sm text-green-950 font-medium italic">
              by {applicationDetails?.from_displayname}
            </span>
          </div>

          <IconButton
            onClick={onClose}
            className="text-white hover:bg-white hover:bg-opacity-20 rounded-full p-2 transition-colors"
            aria-label="close"
          >
            <CloseIcon className="text-white" />
          </IconButton>
        </div>

        <div
          className="overflow-y-auto max-h-[calc(90vh-88px)]"
          style={{
            scrollbarWidth: "thin",
            scrollbarColor: "#e5e7eb transparent",
          }}
        >
          <div className="p-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <>
                <div className="md:col-span-2">
                  <div className="bg-gray-50 p-6 rounded-lg flex justify-between items-start">
                    <div className="flex items-start space-x-6 flex-1">
                      <img
                        src={
                          applicationDetails?.to_profile_img_url ||
                          `${process.env.PUBLIC_URL}/images/placeholder/avatar.png`
                        }
                        alt={
                          applicationDetails?.inf_displayname || "Influencer"
                        }
                        className="w-20 h-20 rounded-full object-cover flex-shrink-0"
                        onError={({ currentTarget }) => {
                          currentTarget.onerror = null;
                          currentTarget.src = `${process.env.PUBLIC_URL}/images/placeholder/avatar.png`;
                        }}
                      />
                      <div className="flex-1">
                        <p className="text-xl font-bold text-gray-900 mb-2">
                          {applicationDetails?.to_displayname || "N/A"}
                        </p>
                        <div className="mb-4">
                          <InfluencerRating
                            infrating={applicationDetails?.to_rating}
                          />
                        </div>
                        <div className="flex gap-8">
                          <div className="text-center">
                            <p className="text-xs font-semibold text-gray-600 uppercase tracking-wide mb-1">
                              Followers
                            </p>
                            <p className="text-lg text-gray-900">
                              {applicationDetails?.to_followers?.toLocaleString() ||
                                "N/A"}
                            </p>
                          </div>
                          <div className="text-center">
                            <p className="text-xs font-semibold text-gray-600 uppercase tracking-wide mb-1">
                              Engagement Rate
                            </p>
                            <p className="text-lg text-gray-900">
                              {applicationDetails?.to_engagement_rate
                                ? `${applicationDetails.to_engagement_rate}%`
                                : "N/A"}
                            </p>
                          </div>
                          {applicationDetails?.price && (
                            <div className="text-center">
                              <p className="text-xs font-semibold text-gray-600 uppercase tracking-wide mb-1">
                                Asking Price
                              </p>
                              <p className="text-lg text-gray-900">
                                {applicationDetails?.price
                                  ? `$ ${applicationDetails?.price}`
                                  : "NA"}
                              </p>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="flex flex-col items-end gap-3 px-3 py-2 min-w-[180px]">
                      {applicationDetails?.campaign?.cmp_type && (
                        <div className="flex items-center gap-2">
                          {getOfferTypeBadge(
                            applicationDetails.campaign.cmp_type
                          )}
                        </div>
                      )}

                      <div className="flex items-center gap-2">
                        <p className="text-xs font-semibold text-gray-600 uppercase tracking-wide">
                          Status :
                        </p>
                        {statusRender(applicationDetails?.status)}
                      </div>
                    </div>
                  </div>
                </div>
                {applicationDetails?.campaign?.title && (
                  <div>
                    <p className="text-sm font-semibold text-gray-600 mb-1 uppercase tracking-wide">
                      Title
                    </p>
                    <p className="text-base text-gray-900 bg-gray-50 p-3 rounded-lg">
                      {getPlatformIcon(applicationDetails?.campaign?.title)}
                    </p>
                  </div>
                )}
                {applicationDetails?.social_media_code && (
                  <div>
                    <p className="text-sm font-semibold text-gray-600 mb-1 uppercase tracking-wide">
                      Social Platform
                    </p>
                    <p className="text-base text-gray-900 bg-gray-50 p-3 rounded-lg">
                      {getPlatformIcon(applicationDetails?.social_media_code)}
                    </p>
                  </div>
                )}
                {applicationDetails?.campaign?.delivery_date && (
                  <div className="space-y-4">
                    <div>
                      <p className="text-sm font-semibold text-gray-600 mb-1 uppercase tracking-wide">
                        Delivery Date
                      </p>
                      <p className="text-base text-gray-900 bg-gray-50 p-3 rounded-lg">
                        {applicationDetails?.campaign?.delivery_date
                          ? new Date(
                              applicationDetails?.campaign?.delivery_date
                            ).toLocaleDateString()
                          : "Not specified"}
                      </p>
                    </div>
                  </div>
                )}
                {applicationDetails?.campaign?.category_name && (
                  <div>
                    <p className="text-sm font-semibold text-gray-600 mb-1 uppercase tracking-wide">
                      Category Name
                    </p>
                    <p className="text-base text-gray-900 bg-gray-50 p-3 rounded-lg">
                      {getPlatformIcon(
                        applicationDetails?.campaign?.category_name
                      )}
                    </p>
                  </div>
                )}
                {applicationDetails?.campaign?.hashtag && (
                  <div>
                    <p className="text-sm font-semibold text-gray-600 mb-1 uppercase tracking-wide">
                      Hashtag
                    </p>
                    <p className="text-base text-gray-900 bg-gray-50 p-3 rounded-lg">
                      {getPlatformIcon(applicationDetails?.campaign?.hashtag)}
                    </p>
                  </div>
                )}
                {applicationDetails?.campaign?.platform_name && (
                  <div>
                    <p className="text-sm font-semibold text-gray-600 mb-1 uppercase tracking-wide">
                      Platform
                    </p>
                    <p className="text-base text-gray-900 bg-gray-50 p-3 rounded-lg">
                      {applicationDetails?.campaign.platform_name}
                    </p>
                  </div>
                )}
                {applicationDetails?.campaign?.reach_min && (
                  <div>
                    <p className="text-sm font-semibold text-gray-600 mb-1 uppercase tracking-wide">
                      Minimum Reach
                    </p>
                    <p className="text-base text-gray-900 bg-gray-50 p-3 rounded-lg">
                      {applicationDetails?.campaign.reach_min?.toLocaleString()}
                    </p>
                  </div>
                )}
                {applicationDetails?.campaign?.location_name && (
                  <div>
                    <p className="text-sm font-semibold text-gray-600 mb-1 uppercase tracking-wide">
                      Location
                    </p>
                    <p className="text-base text-gray-900 bg-gray-50 p-3 rounded-lg">
                      {getPlatformIcon(
                        applicationDetails?.campaign?.location_name
                      )}
                    </p>
                  </div>
                )}
                 {applicationDetails?.campaign?.ctr_url && (
                  <div className="md:col-span-2">
                    <p className="text-sm font-semibold text-gray-600  mb-1 uppercase tracking-wide">
                      Landing Page URL
                    </p>
                    <div className="text-base text-gray-900 bg-gray-50 p-3 rounded-lg ">
                      <p className="text-base text-gray-900 font-medium">
                        {applicationDetails?.campaign?.ctr_url}
                      </p>
                    </div>
                  </div>
                )}
                {applicationDetails?.description && (
                  <div className="md:col-span-2">
                    <p className="text-sm font-semibold text-gray-600  mb-1 uppercase tracking-wide">
                      Description
                    </p>
                    <div className="text-base text-gray-900 bg-gray-50 p-3 rounded-lg ">
                      <p className="text-base text-gray-900 font-medium">
                        {applicationDetails?.description}
                      </p>
                    </div>
                  </div>
                )}
                {applicationDetails?.campaign?.compensation && (
                  <div className="md:col-span-2">
                    <p className="text-sm font-semibold text-gray-600  mb-1 uppercase tracking-wide">
                      Compensation
                    </p>
                    <div className="text-base text-gray-900 bg-gray-50 p-3 rounded-lg ">
                      <p className="text-base text-gray-900 font-medium">
                        {applicationDetails?.campaign?.compensation}
                      </p>
                    </div>
                  </div>
                )}
                {applicationDetails?.campaign?.additional_info && (
                  <div className="md:col-span-2">
                    <p className="text-sm font-semibold text-gray-600  mb-1 uppercase tracking-wide">
                      Additional Information
                    </p>
                    <div className="text-base text-gray-900 bg-gray-50 p-3 rounded-lg ">
                      <p className="text-base text-gray-900 font-medium">
                        {applicationDetails?.campaign?.additional_info}
                      </p>
                    </div>
                  </div>
                )}
                {applicationDetails?.campaign?.scope_of_work && (
                  <div className="md:col-span-2">
                    <p className="text-sm font-semibold text-gray-600 mb-3 uppercase tracking-wide">
                      Scope of Work
                    </p>
                    <div className="text-base text-gray-900 bg-gray-50 p-3 rounded-lg">
                      <p className="text-base text-gray-900 whitespace-pre-wrap leading-relaxed">
                        {applicationDetails?.campaign.scope_of_work}
                      </p>
                    </div>
                  </div>
                )}
                {applicationDetails?.campaign?.delivery_info && (
                  <div className="md:col-span-2">
                    <p className="text-sm font-semibold text-gray-600 mb-3 uppercase tracking-wide">
                      Delivery Information
                    </p>
                    <div className="text-base text-gray-900 bg-gray-50 p-3 rounded-lg">
                      <p className="text-base text-gray-900 whitespace-pre-wrap leading-relaxed">
                        {applicationDetails?.campaign.delivery_info}
                      </p>
                    </div>
                  </div>
                )}
                 {applicationDetails?.campaign?.files && applicationDetails?.campaign?.files.length > 0 && (
                  <div className="md:col-span-2">
                    <p className="text-sm font-semibold text-gray-600 mb-3 uppercase tracking-wide">
                      Attached Files
                    </p>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                      {applicationDetails?.campaign?.files.map((file, index) => {
                        const fileExtension = file.file_name
                          .split(".")
                          .pop()
                          .toLowerCase();
                        const isImage = [
                          "png",
                          "jpg",
                          "jpeg",
                          "gif",
                          "webp",
                          "bmp",
                        ].includes(fileExtension);
                        const isVideo = [
                          "mp4",
                          "avi",
                          "mov",
                          "wmv",
                          "flv",
                          "webm",
                          "mkv",
                        ].includes(fileExtension);

                        return (
                          <div
                            key={index}
                            className="bg-white border border-gray-200 rounded-xl p-4 hover:shadow-lg transition-all duration-200 hover:border-green-300 group"
                          >
                            {/* File Preview Section */}
                            <div className="mb-3 flex justify-center">
                              {isImage ? (
                                <div className="relative w-full h-32 rounded-lg overflow-hidden">
                                  <img
                                    src={file.file_url}
                                    alt={file.file_name}
                                    className="w-full h-full object-cover cursor-pointer hover:scale-105 transition-transform duration-200"
                                    onClick={() =>
                                      window.open(file.file_url, "_blank")
                                    }
                                  />
                                  <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-10 transition-all duration-200" />
                                </div>
                              ) : isVideo ? (
                                <div className="relative w-full h-32 rounded-lg overflow-hidden bg-gray-100">
                                  <video
                                    className="w-full h-full object-cover rounded-lg"
                                    controls
                                    controlsList="nodownload"
                                  >
                                    <source
                                      src={file.file_url}
                                      type={`video/${fileExtension}`}
                                    />
                                    Your browser does not support the video tag.
                                  </video>
                                </div>
                              ) : (
                                <div className="w-full h-32 flex items-center justify-center bg-green-50 rounded-lg border-2 border-dashed border-green-200">
                                  <FileIcon fileName={file.file_name} />
                                </div>
                              )}
                            </div>

                            {/* File Info Section */}
                            <div className="flex items-start gap-3">
                              <div className="flex-shrink-0 mt-1">
                                <FileIcon fileName={file.file_name} />
                              </div>
                              <div className="flex-1 min-w-0">
                                <a
                                  href={file.file_url}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="block text-sm font-medium text-gray-900 hover:text-green-700 transition-colors truncate mt-2"
                                  title={file.file_name}
                                >
                                  {file.file_name}
                                </a>
                              </div>
                            </div>

                            {/* Action Button */}
                            <div className="mt-3 pt-3 border-t border-gray-100">
                              <a
                                href={file.file_url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="w-full inline-flex items-center justify-center px-3 py-2 text-xs font-medium text-green-600 bg-green-50 hover:bg-green-100 rounded-lg transition-colors duration-200 border border-green-200 hover:border-green-300"
                              >
                                View File
                              </a>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}

                {(applicationDetails?.created_at ||
                  applicationDetails?.updated_at) && (
                  <div className="md:col-span-2">
                    <div className="bg-gray-50 p-4 rounded-lg">
                      <div className="flex justify-between items-center flex-wrap gap-2">
                        {applicationDetails?.created_at && (
                          <div className="flex items-center gap-2">
                            <span className="text-xs font-medium text-gray-500 uppercase tracking-wide">
                              Created:
                            </span>
                            <span className="text-sm text-gray-700 font-medium">
                              {new Date(
                                applicationDetails?.created_at
                              ).toLocaleDateString("en-US", {
                                year: "numeric",
                                month: "long",
                                day: "numeric",
                                timeZone: "UTC",
                              })}
                            </span>
                          </div>
                        )}
                        {applicationDetails?.expire_date && (
                          <div className="flex items-center gap-2">
                            <span className="text-xs font-medium text-gray-500 uppercase tracking-wide">
                              Expired:
                            </span>
                            <span className="text-sm text-gray-700 font-medium">
                              {new Date(
                                applicationDetails.expire_date
                              ).toLocaleDateString("en-US", {
                                year: "numeric",
                                month: "long",
                                day: "numeric",
                                timeZone: "UTC",
                              })}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default BrandOfferDetails;
